// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--7-2!./viewer.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("49b008fe", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/viewerjs/dist/viewer.css
// module id = 788
// module chunks = 2 3 4 5 9